export const sponsorshipKeys = {
  all: ["sponsorships"],
  lists: () => [...sponsorshipKeys.all, "list"],
  list: () => [...sponsorshipKeys.lists()],
  details: () => [...sponsorshipKeys.all, "detail"],
  detail: (id) => [...sponsorshipKeys.details(), id],
};
